import React, { useState } from "react";
import closeEyeIcon from "../../assets/close-eye-icon.svg";
import openEyeICon from "../../assets/visibility.svg";
import "./EyeComponent.css";
import { updateDisableProduct } from "../../api/EyeHideAPI";
import { productEndPoints } from "../../constants/endpoints";

interface EyeComponentProps {
  productID: string;
  disabled?: boolean;
}

const EyeComponent: React.FC<EyeComponentProps> = ({ productID, disabled }) => {
  const [disable, setdisable] = useState(disabled);

  const handleEye = async () => {
    try {
      const product = await updateDisableProduct(
        productEndPoints.editProduct,
        productID,
        !disable
      );
      if (product) {
        setdisable(product.disabled);
      }
    } catch (error) {
      console.error("Failed to update product visibility: ", error);
    }
  };

  return (
    <div className="eyeComponent">
      <img
        src={disable ? closeEyeIcon : openEyeICon}
        alt="icon"
        onClick={handleEye}
      />
    </div>
  );
};

export default EyeComponent;
